import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL || 'http://localhost:3001',
});

instance.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});
 async function refreshTokenRequest() {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) throw new Error("No refresh token");

  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/auth/refresh`, {
    method: "POST",
    headers: { "Content-Type": "application/json",
      "Authorization": `Bearer ${refreshToken}`
     },
    
  });

  if (!response.ok) throw new Error("Refresh failed");
  var data = await response.json();
  console.log('Data from refresh token request:', data);

  return data;
}

instance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    if (
      (err.response?.status === 401 || 
       (err.response?.status === 403 && err.response?.data?.message === "Invalid token")) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      console.log("Attempting to refresh token...interceptors");
      try {
        const data = await refreshTokenRequest();
        localStorage.setItem('accessToken', data.data.accessToken);

        originalRequest.headers['Authorization'] = `Bearer ${data.accessToken}`;
        return instance(originalRequest);
      } catch (refreshErr) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        // Optional: redirect to login page
        window.location.href = '/login';
console.log("Refresh token failed:", refreshErr);
        return Promise.reject(refreshErr);
      }
    }
    return Promise.reject(err);
  }
);

export default instance;
export { refreshTokenRequest };
